export const breadcrumbs = [
  {
    text: "Главная",
    disabled: false,
    href: "/",
  },
  {
    text: "Отчёты: Опись дел, документов",
    disabled: true,
    href: "breadcrumbs_link_1",
  },
];
